import { ghlFetchWithTimeout, GHL_WEBHOOK_USER_AGENT } from "./ghlSenderHttp";

type FollowUp = { status: string; next_action: string; due_date: string };

// Keys from the full payload that follow-up posts need to route/identify the contact in GHL.
// Intentionally excludes contact-data fields (notes, address, budget, etc.) so GHL automation
// does not re-apply them on every follow-up webhook and cause duplication.
const FOLLOW_UP_IDENTITY_KEYS = [
  "bb_lead_id",
  "bb_version",
  "bb_salesperson_name",
  "bb_salesperson_cell",
  "bb_salesperson_email",
  "bb_location_id",
  "bb_location_name",
  "origin_location_id",
  "origin_location_name",
  "first_name",
  "last_name",
  "phone",
  "email",
] as const;

function buildFollowUpIdentityContext(payload: Record<string, unknown>): Record<string, unknown> {
  const ctx: Record<string, unknown> = {};
  for (const key of FOLLOW_UP_IDENTITY_KEYS) {
    if (key in payload) ctx[key] = payload[key];
  }
  return ctx;
}

export async function postGhlOpenFollowUps(
  webhookUrl: string,
  payload: Record<string, unknown>,
  followUps: FollowUp[] | undefined,
): Promise<void> {
  if (!Array.isArray(followUps)) return;
  const open = followUps.filter((f) => f.status === "open");
  const identity = buildFollowUpIdentityContext(payload);
  for (const f of open) {
    const taskRes = await ghlFetchWithTimeout(
      webhookUrl,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "User-Agent": GHL_WEBHOOK_USER_AGENT,
        },
        body: JSON.stringify({
          ...identity,
          bb_action: "create_followup_task",
          bb_followup_next_action: f.next_action,
          bb_followup_due_date: f.due_date,
        }),
      },
      6000,
    );
    if (taskRes.ok) continue;
    await ghlFetchWithTimeout(
      webhookUrl,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "User-Agent": GHL_WEBHOOK_USER_AGENT,
        },
        body: JSON.stringify({
          ...identity,
          bb_action: "create_followup_note_fallback",
          bb_followup_note: `${f.next_action} (due ${f.due_date})`,
        }),
      },
      6000,
    );
  }
}
